import { Crown } from "lucide-react";
import type { FieldErrors, UseFormRegister } from "react-hook-form";
import { NetworkIcon } from "./brand-icons";
import { FieldError } from "./ui";
import { formFieldClass } from "./ui-classes";
import { NETWORK_BY_FIELD, NETWORK_FIELD_ORDER, NETWORK_LABELS, NETWORK_PLACEHOLDERS, isPremiumNetwork } from "../lib/networks";
import { classNames } from "../lib/format";

const networkFieldClass = "[&>span]:items-center [&>span]:justify-start [&>span]:gap-1.5 [&>span]:text-ink [&>span_svg]:size-[15px] [&>span_svg]:text-forest [&>span_.brand-glyph]:fill-current [&>span_em]:ml-auto [&>span_em]:inline-flex [&>span_em]:items-center [&>span_em]:gap-[3px] [&>span_em]:rounded-[10px] [&>span_em]:bg-cream [&>span_em]:px-[7px] [&>span_em]:py-0.5 [&>span_em]:text-[11px] [&>span_em]:font-extrabold [&>span_em]:tracking-[.04em] [&>span_em]:text-forest [&>span_em]:not-italic";
const networkFieldLockedClass = "[&>span]:text-muted [&>span_svg]:text-muted [&_input]:cursor-not-allowed [&_input]:bg-paper [&_input]:text-muted [&>small]:text-xs [&>small]:text-muted";

// Shared by the onboarding wizard and the profile editor so both offer exactly
// the same networks in the same order under the same plan rules. Premium fields
// stay visible and readable for a free account — a locked field a creator can
// see is what makes the upgrade concrete — but they are disabled, and the API
// enforces the same split regardless of what the form submits.
export function NetworkFields({ register, errors, premium }: {
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  premium: boolean;
}) {
  return (
    <>
      {NETWORK_FIELD_ORDER.map((field) => {
        const locked = isPremiumNetwork(field) && !premium;
        const label = NETWORK_LABELS[NETWORK_BY_FIELD[field]];
        return (
          <label className={classNames(formFieldClass, "network-field", networkFieldClass, locked && "network-field--locked", locked && networkFieldLockedClass)} key={field}>
            <span>
              <NetworkIcon network={NETWORK_BY_FIELD[field]} size={15} />
              {label}
              {locked && <em><Crown size={12} aria-hidden="true" /> Premium</em>}
            </span>
            <input
              {...register(field)}
              disabled={locked}
              placeholder={locked ? "Disponível no Premium" : NETWORK_PLACEHOLDERS[field]}
              aria-describedby={locked ? `${field}-locked` : undefined}
            />
            {locked && <small id={`${field}-locked`}>Assine o Premium para exibir esta rede no seu perfil.</small>}
            <FieldError>{errors[field]?.message as string | undefined}</FieldError>
          </label>
        );
      })}
    </>
  );
}
